interface IEnvCfg {
  version: string;
  auth_host: string;
  api_host: string;
  loginUrl: string;
  registerUrl: string;
  noPermissionsUrl: string;
}
export const server = import.meta.env.SERVER;
export const host = import.meta.env.HOST;
export const fcHost = import.meta.env.FC_HOSTNAME;
export const debugMode = new URL(host)?.hostname === 'localhost';
export const EnvConst: IEnvCfg = {
  version: `${import.meta.env.VERSION}`,
  auth_host: `${server}/auth`,
  api_host: `${server}/api/v1`,
  loginUrl: `${server}/auth/login`,
  registerUrl: `${fcHost}/cred/#/sign-up`,
  noPermissionsUrl: `${fcHost}/asset`
};
/**
 * @description Need modification to adapt sandbox?
 */
export const HomeElms = {
  name: 'FortiSandbox',
  fcName: 'FortiSandboxCloud'
};

export const InstanceAction = {
  resize: 'resize',
  upgrade: 'upgrade',
  reboot: 3,
  createSnapshot: 4,
  revertSnapshot: 5
};

console.info('const config---------------', server, host, EnvConst);
